import React from 'react';
import { Create, Form, Input, Select, useForm } from '@pankod/refine-antd';
import { UserTypes } from 'interfaces';
import { OpenNotificationParams } from '@pankod/refine-core';
import { USER_ROLES } from 'constant';

const UserCreate: React.FC = () => {
  const { formProps, saveButtonProps,  } = useForm<UserTypes>({
    onMutationSuccess(data, variables, context) {
      return Promise.resolve('/users');
    },

    errorNotification(error: any, variables, context): OpenNotificationParams {
      return {
        message: error?.response?.errors[0]?.message,
        type: 'error',
      };
    },
  });

  
  return (
    <Create  saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout='vertical'
        onFinish={(values: any) =>
          formProps.onFinish?.({
            name: values.name,
            email: values.email,
            role: values.role,
            password: values.password,
          } as any)
        }
      >
        <Form.Item
          label='Name'
          name='name'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Email'
          name='email'
          rules={[
            {
              type: 'email',
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Role'
          name='role'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select
            placeholder='Role'
            options={[
              {
                label: 'Super Admin',
                value: USER_ROLES.SUPER_ADMIN,
              },
              {
                label: 'Admin',
                value: USER_ROLES.ADMIN,
              },
            ]}
          />
        </Form.Item>
        <Form.Item
          label='Password'
          name='password'
          hasFeedback
          rules={[
            {
              required: true,
              pattern:
                /^(?=.*[0-8])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
              message:
                'Password must contain one digit from 1 to 8, one lowercase letter, one uppercase letter, one special character, no space, and it must be 8-16 characters long.',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label='Confirm Password'
          name='confirm_password'
          dependencies={['password']}
          hasFeedback
          rules={[
            {
              required: true,

              pattern:
                /^(?=.*[0-8])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
              message:
                'Password must contain one digit from 1 to 8, one lowercase letter, one uppercase letter, one special character, no space, and it must be 8-16 characters long.',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('The two passwords that you entered do not match!')
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Create>
  );
};

export default UserCreate;
